import React from 'react'

export const ChatMediaFocusSelectedIcon = ({
  size = 30,
  className,
  opacity = 1,
}: {
  color?: string
  size?: number
  className?: string
  opacity?: number
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      className={className}
      fill="none"
      opacity={opacity}
    >
      <g>
        <path
          d="M18.75 6C20.9591 6 22.75 7.79086 22.75 10V20C22.75 22.2091 20.9591 24 18.75 24H10.75C8.54086 24 6.75 22.2091 6.75 20V10C6.75 7.79086 8.54086 6 10.75 6H18.75ZM11.5 16C10.3954 16 9.5 16.8954 9.5 18C9.5 19.1046 10.3954 20 11.5 20C12.6046 20 13.5 19.1046 13.5 18C13.5 16.8954 12.6046 16 11.5 16ZM16 17.25C15.5858 17.25 15.25 17.5858 15.25 18C15.25 18.4142 15.5858 18.75 16 18.75H19C19.4142 18.75 19.75 18.4142 19.75 18C19.75 17.5858 19.4142 17.25 19 17.25H16ZM11.5 17.5C11.7761 17.5 12 17.7239 12 18C12 18.2761 11.7761 18.5 11.5 18.5C11.2239 18.5 11 18.2761 11 18C11 17.7239 11.2239 17.5 11.5 17.5ZM11.5 10C10.3954 10 9.5 10.8954 9.5 12C9.5 13.1046 10.3954 14 11.5 14C12.6046 14 13.5 13.1046 13.5 12C13.5 10.8954 12.6046 10 11.5 10ZM16 11.25C15.5858 11.25 15.25 11.5858 15.25 12C15.25 12.4142 15.5858 12.75 16 12.75H19C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H16ZM11.5 11.5C11.7761 11.5 12 11.7239 12 12C12 12.2761 11.7761 12.5 11.5 12.5C11.2239 12.5 11 12.2761 11 12C11 11.7239 11.2239 11.5 11.5 11.5Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default ChatMediaFocusSelectedIcon
